import Aion from '@adoratorio/aion';

const aion = new Aion();

export default aion;